import { z } from "zod";
import {translateFunc} from "@/utils/translateFunc";

const useAuthValidationSchema = ()=>{
    const signUpSchema = z.object({
        email: z.string().email(translateFunc('invalid-email')),
        password: z.string()
            .min(6, translateFunc('min-password'))
            .max(50, translateFunc('max-password'))
            .regex(/[a-z]/, translateFunc('required-lowercase'))
            .regex(/[A-Z]/, translateFunc('required-uppercase'))
            .regex(/[0-9]/, translateFunc('required-number'))
            .regex(/[\W_]/, translateFunc('required-special-char')),
        confirmPassword: z.string(),
    }).refine((data) => data.password === data.confirmPassword, {
        path: ['confirmPassword'],
        message: translateFunc('confirm-pass-not-matched'),
    });

    const loginSchema = z.object({
        email: z.string().email(translateFunc('invalid-email')),
        password: z.string()
            .min(6, translateFunc('min-password'))
            .max(50, translateFunc('max-password')),
    });

    const resetReqSchema = z.object({
        email: z.string().email(translateFunc('invalid-email')),
    });

    const resetSchema = z.object({
        token: z.string().min(10, "Invalid token detected!"),
        password: z.string()
            .min(6, translateFunc('min-password'))
            .max(50, translateFunc('max-password'))
            .regex(/[a-z]/, translateFunc('required-lowercase'))
            .regex(/[A-Z]/, translateFunc('required-uppercase'))
            .regex(/[0-9]/, translateFunc('required-number'))
            .regex(/[\W_]/, translateFunc('required-special-char')),
        confirmPassword: z.string(),
    }).refine((data) => data.password === data.confirmPassword, {
        path: ['confirmPassword'],
        message: translateFunc('confirm-pass-not-matched'),
    });

    const changePasswordSchema = z.object({
        currentPassword: z.string()
            .min(6, translateFunc('min-password'))
            .max(50, translateFunc('max-password')),
        newPassword: z.string()
            .min(6, translateFunc('min-password'))
            .max(50, translateFunc('max-password'))
            .regex(/[a-z]/, translateFunc('required-lowercase'))
            .regex(/[A-Z]/, translateFunc('required-uppercase'))
            .regex(/[0-9]/, translateFunc('required-number'))
            .regex(/[\W_]/, translateFunc('required-special-char')),
        confirmPassword: z.string(),
    }).refine((data) => data.newPassword === data.confirmPassword, {
        path: ['confirmPassword'],
        message: translateFunc('confirm-pass-not-matched'),
    });

    return {signUpSchema,loginSchema, resetReqSchema, resetSchema, changePasswordSchema};
}

export default useAuthValidationSchema;
